import { useQuery } from "@tanstack/react-query";
import messageRepository from "@/repository/messageRepository";
import { emptyPage, MessageChannel, MessageFeedback, MessageHistorySearchType, SearchedMessage } from "@/model";


interface useMessagesProps {
    scenarioId: string;
    start_date: string;
    end_date: string;
    searchType: MessageHistorySearchType;
    condition?: string;
    channel?: MessageChannel;
    feedback?: MessageFeedback;
}

const getData = async (props: useMessagesProps) => {
    const { scenarioId, start_date, end_date, searchType, condition, channel, feedback } = props;
    const res = await messageRepository.findAll(scenarioId, start_date, end_date, searchType, condition, channel, feedback);
    return res.data || emptyPage<SearchedMessage>();
};

export const useMessages = ({
    scenarioId,
    start_date,
    end_date,
    searchType,
    condition,
    channel,
    feedback
}: useMessagesProps) => {
    return useQuery<SearchedMessage[]>({
        queryKey: ['messages', 'all', scenarioId, start_date, end_date, searchType, condition, channel, feedback],
        queryFn: () => getData({ scenarioId, start_date, end_date, searchType, condition, channel, feedback }),
        enabled: false
    });
}; 